import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import ContentBanner from "../../../../V2/Sections/Banners/Content"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokContentBanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.ContentBanner>) => {
  return (
    <ContentBanner
      header={blok.text}
      superscript={blok.superscript}
      description={blok.description}
      descriptionList={blok.descriptionList}
      verticalLabel={blok.verticalLabel}
      badgeText={blok.badgeText}
      badgeColor={blok.badgeColor}
      reverseOrder={blok.reverseOrder}
      size={blok.size}
      cardBackgroundColor={blok.cardColor}
      secondaryBackgroundColor={blok.secondaryBackgroundColor}
      buttonLink={storyblokLinkToYocoLink(blok.primaryCTALink)}
      buttonText={blok.primaryCTAText}
      buttonBorderColor={blok.primaryCTABorderColor}
      buttonStyle={blok.primaryCTAStyle}
      secondaryCTAText={blok.secondaryCTAText}
      secondaryCTALink={storyblokLinkToYocoLink(blok.secondaryCTALink)}
      secondaryCTAStyle={blok.secondaryCTAStyle}
      imageAlt={blok.image?.alt}
      imageUrl={blok.image?.filename}
      mobileImageUrl={blok.mobileImage?.filename}
      showLogo={blok.showLogo}
      headerLabel={blok.headerLabel}
      mobileGridOrder={mobileGridOrder}
      trackingEvent={blok.trackingEvent}
      trackingEventKey={blok.trackingEventKey}
      trackingEventValue={blok.trackingEventValue}
      disclaimer={blok.disclaimer}
      descriptionHeader={blok.descriptionHeader}
      videoUrl={blok.video?.filename}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokContentBanner
